import React from 'react';
import { useForm } from 'react-hook-form';

interface RsvpFormProps {
  onSubmit: (data: RsvpFormData) => Promise<void>;
}

export interface RsvpFormData {
  name: string;
  phone: string;
  guestsCount: number;
  message: string;
}

const RsvpForm: React.FC<RsvpFormProps> = ({ onSubmit }) => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<RsvpFormData>();
  
  const onSubmitHandler = async (data: RsvpFormData) => {
    try {
      await onSubmit(data);
    } catch (error) {
      console.error('Error submitting RSVP:', error);
      // Show error notification in a real app
    }
  };

  return (
    <form 
      onSubmit={handleSubmit(onSubmitHandler)}
      className="bg-white rounded-lg shadow-md p-6 max-w-lg mx-auto"
    >
      <div className="mb-4">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
          Nome completo
        </label>
        <input
          id="name"
          type="text"
          className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-wedding-blue-500 ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
          {...register('name', { required: 'Nome é obrigatório' })}
        />
        {errors.name && (
          <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>
        )}
      </div>
      
      <div className="mb-4">
        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
          Telefone
        </label>
        <input
          id="phone"
          type="tel"
          className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-wedding-blue-500 ${errors.phone ? 'border-red-500' : 'border-gray-300'}`}
          {...register('phone', { required: 'Telefone é obrigatório' })}
        />
        {errors.phone && (
          <p className="text-red-500 text-xs mt-1">{errors.phone.message}</p>
        )}
      </div>
      
      <div className="mb-4">
        <label htmlFor="guestsCount" className="block text-sm font-medium text-gray-700 mb-1">
          Quantidade de acompanhantes
        </label>
        <input
          id="guestsCount"
          type="number"
          min="0"
          className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-wedding-blue-500 ${errors.guestsCount ? 'border-red-500' : 'border-gray-300'}`}
          {...register('guestsCount', { 
            required: 'Este campo é obrigatório',
            min: { value: 0, message: 'O valor mínimo é 0' },
            valueAsNumber: true
          })}
        />
        {errors.guestsCount && (
          <p className="text-red-500 text-xs mt-1">{errors.guestsCount.message}</p>
        )}
      </div>
      
      <div className="mb-6">
        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
          Mensagem aos noivos (opcional)
        </label>
        <textarea
          id="message"
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-wedding-blue-500"
          {...register('message')}
        />
      </div>
      
      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full py-3 bg-wedding-blue-600 text-white rounded-md hover:bg-wedding-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        {isSubmitting ? 'Enviando...' : 'Confirmar Presença'}
      </button>
    </form>
  );
};

export default RsvpForm;